<template>
  <div class="mt-4 mx-3 row white-box px-3 py-4">
    <div class="white-box-top"></div>
    <div class="col-md-4 col-lg-2">
      <nav class="left-nav">
        <button
          class="btn w-100 text-start"
          v-on:click="activeTab = 'webstores'"
          :class="activeTab === 'webstores' ? 'btn-primary' : 'btn-simple'"
        >
          Webstores
        </button>
        <button
          class="btn w-100 text-start"
          v-on:click="activeTab = 'strategies'"
          :class="activeTab === 'strategies' ? 'btn-primary' : 'btn-simple'"
        >
          Matching Strategies
        </button>
        <button
          class="btn w-100 text-start"
          v-on:click="activeTab = 'alerts'"
          :class="activeTab === 'alerts' ? 'btn-primary' : 'btn-simple'"
        >
          Alert & Price Rules
        </button>
      </nav>
    </div>
    <div class="col-md-8 col-lg-10">
      <div class="row" v-if="activeTab === 'webstores'">
        <div class="col-md-4 col-lg-3">
          <nav class="left-nav">
            <h4 class="mb-2">Webstores</h4>
            <div class="items">
              <button
                v-for="webstore in webstores"
                :key="webstore.id"
                class="btn w-100 text-start"
                :class="[
                  webstore.id === selectedWebstore?.id
                    ? 'btn-primary'
                    : 'btn-simple',
                ]"
                v-on:click="selectedWebstore = webstore"
              >
                {{ webstore.name }}
              </button>
              <button
                class="btn w-100 text-start"
                :class="!selectedWebstore?.id ? 'btn-primary' : 'btn-simple'"
                v-on:click="
                  selectedWebstore = {
                    scrape_sitemap: true,
                    currency_code:
                      $store.state.currencies.length > 0
                        ? $store.state.currencies[0].code
                        : null,
                  }
                "
              >
                {{
                  !selectedWebstore?.id && selectedWebstore?.name
                    ? "+ " + selectedWebstore?.name
                    : "+ new webstore"
                }}
              </button>
            </div>
          </nav>
        </div>
        <div class="col-md-8 col-lg-9" v-if="selectedWebstore">
          <section id="basics">
            <h2>Price Comparison</h2>
            <h4 v-if="selectedWebstore.id">Webstore Settings</h4>
            <h4 v-else>New Webstore</h4>

            <div class="row text-start custom-input whitebg-input mt-4">
              <div class="row mb-3">
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray">Name</label>
                  <input
                    type="text"
                    class="form-control remove-padding"
                    placeholder="Example Store"
                    v-model="selectedWebstore.name"
                  />
                </div>
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray">URL</label>
                  <input
                    type="text"
                    class="form-control remove-padding"
                    placeholder="https://example.com"
                    v-model="selectedWebstore.url"
                  />
                </div>
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray">Currency</label>
                  <v-select
                    :options="$store.state.currencies"
                    label="code"
                    :reduce="(option) => option.code"
                    v-model="selectedWebstore.currency_code"
                    class="remove-padding-v-select"
                  >
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        No results found for <em>{{ search }}</em
                        >.
                      </template>
                      <em v-else style="opacity: 0.5"
                        >Start typing to search</em
                      >
                    </template>
                    <template v-slot:selected-option="option">
                      <div class="row">
                        <div class="col">
                          {{ option.code }}
                        </div>
                      </div>
                    </template>
                    <template v-slot:option="option">
                      <div class="row">
                        <div class="col">
                          {{ option.code }}
                        </div>
                      </div>
                    </template>
                  </v-select>
                </div>
                <div class="col-6 mb-3">
                  <label class="cstm-check d-flex align-items-center mt-4">
                    <span class="regular-14 text-black mx-2"
                      >Scrape Sitemap</span
                    >
                    <input
                      type="checkbox"
                      v-model="selectedWebstore.scrape_sitemap"
                    />
                    <span class="checkmark mx-2"></span>
                  </label>
                </div>
                <div class="col-12 mb-3" v-if="selectedWebstore.id">
                  <label class="cstm-check d-flex align-items-center">
                    <span class="regular-14 text-black mx-2"
                      >Enabled for Comparison</span
                    >
                    <input
                      type="checkbox"
                      v-model="selectedWebstore.is_enabled"
                      @change="toggleWebshop"
                    />
                    <span class="checkmark mx-2"></span>
                  </label>
                </div>
              </div>
            </div>

            <div class="row mb-3 d-grid justify-content-end me-4">
              <button
                type="submit"
                class="btn btn-type-2 btn-normal"
                v-on:click="save"
              >
                <span>Save</span>
              </button>
            </div>
          </section>
        </div>
      </div>

      <div class="row" v-if="activeTab === 'strategies'">
        <div class="col-md-4 col-lg-3">
          <nav class="left-nav">
            <h4 class="mb-2">Strategies</h4>
            <div class="items">
              <button
                v-for="strategy in matchingStrategies"
                :key="strategy.id"
                class="btn w-100 text-start"
                :class="[
                  strategy.id === selectedStrategy?.id
                    ? 'btn-primary'
                    : 'btn-simple',
                ]"
                v-on:click="selectedStrategy = strategy"
              >
                {{ strategy.name }}
              </button>
              <button
                class="btn w-100 text-start"
                :class="!selectedStrategy?.id ? 'btn-primary' : 'btn-simple'"
                v-on:click="selectedStrategy = { is_active: true, priority: 0 }"
              >
                {{
                  !selectedStrategy?.id && selectedStrategy?.name
                    ? "+ " + selectedStrategy?.name
                    : "+ new strategy"
                }}
              </button>
            </div>
          </nav>
        </div>
        <div class="col-md-8 col-lg-9" v-if="selectedStrategy">
          <section id="strategy-details">
            <div class="row">
              <div class="col">
                <h2>Matching Strategy</h2>
                <h4 v-if="selectedStrategy.id">Edit Strategy</h4>
                <h4 v-else>New Strategy</h4>
              </div>
              <div class="col-auto">
                <button
                  v-if="selectedStrategy.id"
                  class="btn btn-link"
                  v-on:click="deleteStrategy"
                >
                  <span>
                    <BaseIcon name="trash" />
                  </span>
                </button>
              </div>
            </div>
            <div class="row text-start custom-input whitebg-input mt-4">
              <div class="row mb-3">
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray">Name</label>
                  <input
                    type="text"
                    class="form-control remove-padding"
                    placeholder="Strategy Name"
                    v-model="selectedStrategy.name"
                  />
                </div>
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray"
                    >Identifier Type</label
                  >
                  <select
                    class="form-control"
                    v-model="selectedStrategy.identifier_type"
                  >
                    <option value="SKU">SKU</option>
                    <option value="EAN">EAN</option>
                    <option value="UPC">UPC</option>
                  </select>
                </div>
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray">Rule</label>
                  <select class="form-control" v-model="selectedStrategy.rule">
                    <option value="exact">Exact Match</option>
                    <option value="starts_with">
                      Their identifier starts with mine
                    </option>
                    <option value="ends_with">
                      Their identifier ends with mine
                    </option>
                    <option value="contains">
                      Their identifier contains mine
                    </option>
                    <option value="my_ends_with">
                      My identifier ends with theirs
                    </option>
                    <option value="my_contains">
                      My identifier contains theirs
                    </option>
                  </select>
                </div>
                <div
                  class="col-6 mb-3"
                  v-if="selectedStrategy.rule !== 'exact'"
                >
                  <label class="form-label bold-12 text-gray"
                    >Maximum character differencies</label
                  >
                  <input
                    type="number"
                    class="form-control remove-padding"
                    v-model="selectedStrategy.max_diff_chars"
                  />
                </div>
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray">Priority</label>
                  <input
                    type="number"
                    class="form-control remove-padding"
                    v-model="selectedStrategy.priority"
                  />
                </div>
                <div class="col-12 mb-3">
                  <label class="form-label bold-12 text-gray">Category</label>
                  <v-select
                    :options="categories"
                    v-model="selectedStrategy.category_id"
                    label="name"
                    :reduce="(c) => c.id"
                    :placeholder="$t(`finance.notSelected`)"
                    append-to-body
                  />
                </div>
                <div class="col-12 mb-3">
                  <label class="form-label bold-12 text-gray">Partner</label>
                  <v-select
                    :options="searchedPartners"
                    v-on:search="fetchPartners"
                    v-model="selectedStrategy.crm_item_id"
                    :filterable="false"
                    :placeholder="$t(`copyProducts.selectProduct`)"
                    :reduce="(c) => c.id"
                    :getOptionKey="(c) => c.id"
                    append-to-body
                  >
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching && search.length > 2">
                        {{ $t("copyProducts.noProductsFoundFor") }}
                        <em>{{ search }}</em
                        >.
                      </template>
                      <span v-else>
                        {{
                          $t(`newManualIncoming.startTypingToSearchForA`, {
                            expr: "partner",
                          })
                        }}</span
                      >
                    </template>
                    <template v-slot:selected-option="option">
                      <div class="row">
                        <div class="col">
                          {{ option.name }}
                        </div>
                      </div>
                    </template>
                    <template v-slot:option="option">
                      <div class="row">
                        <div class="col">
                          {{ option.name }}
                        </div>
                      </div>
                    </template>
                  </v-select>
                </div>
                <div class="col-12 mb-3">
                  <label class="cstm-check d-flex align-items-center">
                    <span class="regular-14 text-black mx-2">Active</span>
                    <input
                      type="checkbox"
                      v-model="selectedStrategy.is_active"
                    />
                    <span class="checkmark mx-2"></span>
                  </label>
                </div>
              </div>
            </div>

            <div class="row mb-3 d-flex justify-content-between me-4">
              <button
                type="submit"
                class="btn btn-type-2 btn-normal"
                v-on:click="saveStrategy"
              >
                <span>Save</span>
              </button>
            </div>
          </section>
        </div>
      </div>
      <div class="row" v-if="activeTab === 'alerts'">
        <div class="col-md-4 col-lg-3">
          <nav class="left-nav">
            <h4 class="mb-2">Alert Rules</h4>
            <div class="items">
              <button
                v-for="setting in alertSettings"
                :key="setting.id"
                class="btn w-100 text-start"
                :class="[
                  setting.id === selectedAlertSetting?.id
                    ? 'btn-primary'
                    : 'btn-simple',
                ]"
                v-on:click="selectedAlertSetting = setting"
              >
                {{ setting.name }}
              </button>
              <button
                class="btn w-100 text-start"
                :class="
                  !selectedAlertSetting?.id ? 'btn-primary' : 'btn-simple'
                "
                v-on:click="
                  selectedAlertSetting = {
                    is_active: true,
                    priority: 0,
                    calculation_strategy: 'min',
                    min_price_strategy_type: 'percent',
                    min_price_strategy_value: 0,
                    max_price_strategy_type: 'percent',
                    max_price_strategy_value: 0,
                    update_method: 'normal',
                    currency_code: 'HUF',
                    rounding_strategy: [],
                    weights: {},
                    type: 'price_change',
                    price_strategies: [],
                  }
                "
              >
                {{
                  !selectedAlertSetting?.id && selectedAlertSetting?.name
                    ? "+ " + selectedAlertSetting?.name
                    : "+ new alert setting"
                }}
              </button>
            </div>
          </nav>
        </div>
        <div class="col-md-8 col-lg-9" v-if="selectedAlertSetting">
          <section id="alert-details">
            <div class="row">
              <div class="col">
                <h2>Alert & Price Rule</h2>
                <h4 v-if="selectedAlertSetting.id">Edit Rule</h4>
                <h4 v-else>New Rule</h4>
              </div>
              <div class="col-auto">
                <button
                  v-if="selectedAlertSetting.id"
                  class="btn btn-link"
                  v-on:click="deleteAlertSetting"
                >
                  <span>
                    <BaseIcon name="trash" />
                  </span>
                </button>
              </div>
            </div>
            <div class="row text-start custom-input whitebg-input mt-4">
              <div class="row mb-3">
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray">Name</label>
                  <input
                    type="text"
                    class="form-control remove-padding"
                    placeholder="Rule Name"
                    v-model="selectedAlertSetting.name"
                  />
                </div>
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray">Currency</label>
                  <v-select
                    :options="$store.state.currencies"
                    v-model="selectedAlertSetting.currency_code"
                    label="code"
                    :reduce="(c) => c.code"
                    placeholder="Select currency"
                    append-to-body
                  />
                </div>
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray"
                    >Calculation Strategy</label
                  >
                  <select
                    class="form-control"
                    v-model="selectedAlertSetting.calculation_strategy"
                  >
                    <option value="min">Minimum competitor price</option>
                    <option value="max">Maximum competitor price</option>
                    <option value="avg">Average competitor price</option>
                    <option value="weighted_avg">Weighted average</option>
                  </select>
                </div>
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray"
                    >Update Method</label
                  >
                  <select
                    class="form-control"
                    v-model="selectedAlertSetting.update_method"
                  >
                    <option value="normal">Update price</option>
                    <option value="discount">Update discount price</option>
                  </select>
                </div>
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray"
                    >Min Price Strategy</label
                  >
                  <div class="input-group">
                    <select
                      class="form-control"
                      v-model="selectedAlertSetting.min_price_strategy_type"
                    >
                      <option value="amount">Amount</option>
                      <option value="percent">Percent</option>
                    </select>
                    <input
                      type="number"
                      class="form-control"
                      v-model="selectedAlertSetting.min_price_strategy_value"
                    />
                  </div>
                </div>
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray"
                    >Max Price Strategy</label
                  >
                  <div class="input-group">
                    <select
                      class="form-control"
                      v-model="selectedAlertSetting.max_price_strategy_type"
                    >
                      <option value="amount">Amount</option>
                      <option value="percent">Percent</option>
                    </select>
                    <input
                      type="number"
                      class="form-control"
                      v-model="selectedAlertSetting.max_price_strategy_value"
                    />
                  </div>
                </div>
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray"
                    >Rounding Strategy</label
                  >
                  <v-select
                    multiple
                    :options="[
                      'to_00',
                      'to_0',
                      'to_05',
                      'to_09',
                      'to_15',
                      'to_25',
                      'to_39',
                      'to_49',
                      'to_50',
                      'to_55',
                      'to_69',
                      'to_75',
                      'to_79',
                      'to_89',
                      'to_90',
                      'to_95',
                      'to_99',

                      'ceil_00',
                      'ceil_0',
                      'ceil_05',
                      'ceil_09',
                      'ceil_15',
                      'ceil_25',
                      'ceil_39',
                      'ceil_49',
                      'ceil_50',
                      'ceil_55',
                      'ceil_69',
                      'ceil_75',
                      'ceil_79',
                      'ceil_89',
                      'ceil_90',
                      'ceil_95',
                      'ceil_99',

                      'floor_00',
                      'floor_0',
                      'floor_05',
                      'floor_09',
                      'floor_15',
                      'floor_25',
                      'floor_39',
                      'floor_49',
                      'floor_50',
                      'floor_55',
                      'floor_69',
                      'floor_75',
                      'floor_79',
                      'floor_89',
                      'floor_90',
                      'floor_95',
                      'floor_99',
                    ]"
                    v-model="selectedAlertSetting.rounding_strategy"
                    placeholder="Select rounding strategies"
                    append-to-body
                  />
                </div>
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray"
                    >Diff Limit %</label
                  >
                  <input
                    type="number"
                    class="form-control remove-padding"
                    v-model="selectedAlertSetting.diff_limit_percentage"
                  />
                </div>
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray"
                    >Max Update Period (min)</label
                  >
                  <input
                    type="number"
                    class="form-control remove-padding"
                    v-model="selectedAlertSetting.max_update_period"
                  />
                </div>
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray">Priority</label>
                  <input
                    type="number"
                    class="form-control remove-padding"
                    v-model="selectedAlertSetting.priority"
                  />
                </div>
                <div class="col-6 mb-3">
                  <label class="form-label bold-12 text-gray">Type</label>
                  <select
                    class="form-control"
                    v-model="selectedAlertSetting.type"
                  >
                    <option value="price_change">Price Change</option>
                    <option value="alert">Alert Only</option>
                  </select>
                </div>

                <div
                  class="col-12 mb-3"
                  v-if="
                    selectedAlertSetting.calculation_strategy === 'weighted_avg'
                  "
                >
                  <label class="form-label bold-12 text-gray"
                    >Webstore Weights</label
                  >
                  <div class="row">
                    <div
                      v-for="webstore in enabledWebstores"
                      :key="webstore.id"
                      class="col-4 mb-2"
                    >
                      <div class="input-group">
                        <span class="input-group-text bold-12">{{
                          webstore.name
                        }}</span>
                        <input
                          type="number"
                          class="form-control"
                          v-model="selectedAlertSetting.weights[webstore.id]"
                          placeholder="Weight"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 mb-3">
                  <label class="form-label bold-12 text-gray"
                    >Price Setting Strategies</label
                  >
                  <div
                    v-for="(
                      strategy, index
                    ) in selectedAlertSetting.price_strategies || []"
                    :key="index"
                    class="row mb-2 align-items-end"
                  >
                    <div class="col-3">
                      <label class="small text-muted">Min Amount</label>
                      <input
                        type="number"
                        class="form-control"
                        v-model="strategy.min"
                        placeholder="Min"
                      />
                    </div>
                    <div class="col-3">
                      <label class="small text-muted">Max Amount</label>
                      <input
                        type="number"
                        class="form-control"
                        v-model="strategy.max"
                        placeholder="Max"
                      />
                    </div>
                    <div class="col-2">
                      <label class="small text-muted">Type</label>
                      <select class="form-control" v-model="strategy.type">
                        <option value="amount">Amount</option>
                        <option value="percent">Percent</option>
                      </select>
                    </div>
                    <div class="col-3">
                      <label class="small text-muted">Value (+/-)</label>
                      <input
                        type="number"
                        class="form-control"
                        v-model="strategy.value"
                        placeholder="Value"
                      />
                    </div>
                    <div class="col-1">
                      <button
                        class="btn btn-link text-danger p-0"
                        @click="
                          selectedAlertSetting.price_strategies.splice(index, 1)
                        "
                      >
                        <BaseIcon name="trash" />
                      </button>
                    </div>
                  </div>
                  <button
                    class="btn btn-sm btn-secondary mt-2"
                    @click="
                      if (!selectedAlertSetting.price_strategies) {
                        $set(selectedAlertSetting, 'price_strategies', []);
                      }
                      selectedAlertSetting.price_strategies.push({
                        min: 0,
                        max: 0,
                        type: 'percent',
                        value: 0,
                      });
                    "
                  >
                    + Add strategy row
                  </button>
                </div>

                <div class="col-12 mb-3">
                  <label class="form-label bold-12 text-gray">Category</label>
                  <v-select
                    :options="categories"
                    v-model="selectedAlertSetting.category_id"
                    label="name"
                    :reduce="(c) => c.id"
                    :placeholder="$t(`finance.notSelected`)"
                    append-to-body
                  />
                </div>
                <div class="col-12 mb-3">
                  <label class="form-label bold-12 text-gray">Partner</label>
                  <v-select
                    :options="searchedPartners"
                    v-on:search="fetchPartners"
                    v-model="selectedAlertSetting.crm_item_id"
                    :filterable="false"
                    :placeholder="$t(`copyProducts.selectProduct`)"
                    :reduce="(c) => c.id"
                    :getOptionKey="(c) => c.id"
                    append-to-body
                  >
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching && search.length > 2">
                        {{ $t("copyProducts.noProductsFoundFor") }}
                        <em>{{ search }}</em
                        >.
                      </template>
                      <span v-else>
                        {{
                          $t(`newManualIncoming.startTypingToSearchForA`, {
                            expr: "partner",
                          })
                        }}</span
                      >
                    </template>
                    <template v-slot:selected-option="option">
                      <div class="row">
                        <div class="col">
                          {{ option.name }}
                        </div>
                      </div>
                    </template>
                    <template v-slot:option="option">
                      <div class="row">
                        <div class="col">
                          {{ option.name }}
                        </div>
                      </div>
                    </template>
                  </v-select>
                </div>
                <div class="col-12 mb-3">
                  <label class="cstm-check d-flex align-items-center">
                    <span class="regular-14 text-black mx-2">Active</span>
                    <input
                      type="checkbox"
                      v-model="selectedAlertSetting.is_active"
                    />
                    <span class="checkmark mx-2"></span>
                  </label>
                </div>
              </div>
            </div>

            <div class="row mb-3 d-flex justify-content-between me-4">
              <button
                type="submit"
                class="btn btn-type-2 btn-normal"
                v-on:click="saveAlertSetting"
              >
                <span>Save</span>
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/modules/http";
import BaseIcon from "../icons/BaseIcon.vue";

export default {
  name: "PriceComparison",
  components: { BaseIcon },
  data() {
    return {
      activeTab: "webstores",
      webstores: [],
      selectedWebstore: undefined,
      matchingStrategies: [],
      selectedStrategy: undefined,
      alertSettings: [],
      selectedAlertSetting: undefined,
      categories: [],
      searchedPartners: [],
    };
  },
  computed: {
    enabledWebstores() {
      return this.webstores.filter((w) => w.is_enabled);
    },
  },
  mounted() {
    this.load();
    this.loadCategories();
    this.loadStrategies();
    this.loadAlertSettings();
  },
  methods: {
    load() {
      http.fetch("/price-comparison/webstores").then((data) => {
        this.webstores = data;
        if (this.webstores.length > 0 && !this.selectedWebstore) {
          this.selectedWebstore = this.webstores[0];
        }
      });
    },
    loadStrategies() {
      http.fetch("/price-comparison/matching-strategies").then((data) => {
        this.matchingStrategies = data;
        if (this.matchingStrategies.length > 0 && !this.selectedStrategy) {
          this.selectedStrategy = this.matchingStrategies[0];
        }
      });
    },
    loadAlertSettings() {
      http.fetch("/price-comparison/alert-settings").then((data) => {
        this.alertSettings = data.map((item) => {
          if (!item.weights) item.weights = {};
          if (!item.price_strategies) item.price_strategies = [];
          if (typeof item.rounding_strategy === "string") {
            item.rounding_strategy = item.rounding_strategy
              ? item.rounding_strategy.split(",")
              : [];
          } else if (!item.rounding_strategy) {
            item.rounding_strategy = [];
          }
          return item;
        });
        if (this.alertSettings.length > 0 && !this.selectedAlertSetting) {
          this.selectedAlertSetting = this.alertSettings[0];
        }
      });
    },
    loadCategories() {
      http.fetch(`/products/products/categories?language=en`).then((data) => {
        this.categories = [];
        this.setUpCategories({ categories: data.data });
      });
    },
    setUpCategories(data, str = "") {
      if (data.categories !== undefined) {
        for (const category of data.categories) {
          this.setUpCategories(
            category,
            data.name !== undefined ? `${str}${data.name} - ` : ""
          );
        }
      } else {
        this.categories.push({
          name: `${str}${data.name}`,
          top: data.name,
          sub: str,
          id: data.id,
        });
      }
    },
    fetchPartners(s, loading) {
      if (s.length < 3) return;
      loading(true);
      http
        .fetch(`/crm/partners?q=${s}&per_page=10`)
        .then((data) => {
          this.searchedPartners = data.data;
          loading(false);
        })
        .catch(() => {
          loading(false);
        });
    },
    toggleWebshop() {
      http.fetch(
        "/price-comparison/toggle-webshop",
        {
          webstore_id: this.selectedWebstore.id,
          is_enabled: this.selectedWebstore.is_enabled,
        },
        true
      );
    },
    save() {
      if (this.selectedWebstore.id) {
        http
          .fetch(
            "/price-comparison/webstore/" + this.selectedWebstore.id,
            this.selectedWebstore,
            true,
            "PUT"
          )
          .then(() => {
            this.load();
          });
      } else {
        http
          .fetch("/price-comparison/webstore", this.selectedWebstore, true)
          .then((data) => {
            this.webstores.push(data);
            this.selectedWebstore = data;
            this.load();
          });
      }
    },
    saveStrategy() {
      if (this.selectedStrategy.id) {
        http
          .fetch(
            "/price-comparison/matching-strategy/" + this.selectedStrategy.id,
            this.selectedStrategy,
            true,
            "PUT"
          )
          .then(() => {
            this.loadStrategies();
          });
      } else {
        http
          .fetch(
            "/price-comparison/matching-strategy",
            this.selectedStrategy,
            true
          )
          .then((data) => {
            this.matchingStrategies.push(data);
            this.selectedStrategy = data;
            this.loadStrategies();
          });
      }
    },
    deleteStrategy() {
      if (
        confirm(
          `Are you sure you want to delete strategy: ${this.selectedStrategy.name}?`
        )
      ) {
        http
          .fetch(
            "/price-comparison/matching-strategy/" + this.selectedStrategy.id,
            {},
            true,
            "DELETE"
          )
          .then(() => {
            this.selectedStrategy = undefined;
            this.loadStrategies();
          });
      }
    },
    saveAlertSetting() {
      const dataToSave = { ...this.selectedAlertSetting };
      if (Array.isArray(dataToSave.rounding_strategy)) {
        dataToSave.rounding_strategy = dataToSave.rounding_strategy.join(",");
      }

      if (this.selectedAlertSetting.id) {
        http
          .fetch(
            "/price-comparison/alert-setting/" + this.selectedAlertSetting.id,
            dataToSave,
            true,
            "PUT"
          )
          .then(() => {
            this.loadAlertSettings();
          });
      } else {
        http
          .fetch("/price-comparison/alert-setting", dataToSave, true)
          .then((data) => {
            this.alertSettings.push(data);
            this.selectedAlertSetting = data;
            this.loadAlertSettings();
          });
      }
    },
    deleteAlertSetting() {
      if (
        confirm(
          `Are you sure you want to delete alert setting: ${this.selectedAlertSetting.name}?`
        )
      ) {
        http
          .fetch(
            "/price-comparison/alert-setting/" + this.selectedAlertSetting.id,
            {},
            true,
            "DELETE"
          )
          .then(() => {
            this.selectedAlertSetting = undefined;
            this.loadAlertSettings();
          });
      }
    },
  },
};
</script>

<style scoped>
.checkmark {
  top: 0;
}
.product-image {
  width: 20px;
  height: 20px;
  object-fit: cover;
  margin-right: 10px;
}
</style>
